import React from 'react';
import { EmployeeLink } from '../../links/index.jsx';
import AnticlockwiseArrow from '../../icons/AnticlockwiseArrow.jsx';
import EmployeeActionDropdown from '../EmployeeActionDropdown.jsx';
import AuthorizedAction from '../../AuthorizedAction.js';
import styles from './EmployeesTableRow.module.css';

const EmployeesTableRow = ({ employee, depth, onEdit, onDelete }) => {
  const {
    id,
    fullName,
    group,
    location,
    position,
    externalId,
    email,
    children,
  } = employee;
  return (
    <tr key={id} className={styles.employeesTableRow}>
      <td style={{ paddingLeft: `${30 + depth * 30}px` }}>
        <div className="flex flex-align-start">
          {children && children.length ? (
            <div className="m-r-2">
              <AnticlockwiseArrow />
            </div>
          ) : (
            <div className="m-l-28"></div>
          )}
          <div className="flex flex-col flex-align-start">
            <h3>
              <EmployeeLink employeeId={id}>{fullName}</EmployeeLink>
            </h3>
            <span>{email}</span>
          </div>
        </div>
      </td>
      <td>{group ? group.name : '—'}</td>
      <td>{location || '—'}</td>
      <td>{position || '—'}</td>
      <td>{externalId || '—'}</td>
      <td>
        <AuthorizedAction action="update" subject="employee">
          <EmployeeActionDropdown
            employee={employee}
            onEdit={onEdit}
            onDelete={onDelete}
          />
        </AuthorizedAction>
      </td>
    </tr>
  );
};

export default EmployeesTableRow;
